import {
  IconButton,
  Tooltip,
  Typography,
  TextField,
  Divider,
  Button,
} from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import { useCallback, useEffect, useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import SearchIcon from "@material-ui/icons/Search";
import React from "react";
import DataService from "../../../../../Service";
import { el } from "date-fns/locale";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
const ColumnsSelector = (props) => {
  const { InitialColumns: columns, setColumns, totalColumns } = props;
  const unCheckable = ["coach_name", "coachee_name", "organisation_name"];

  const [columnsSelectorOpen, setColumnsSelectorOpen] = useState(false);
  const [columnsSelectorAnchor, setColumnsSelectorAnchor] = useState(null);

  const { selectedColumns } = useSelector((state) => state.MIReducer);
  const dispatch = useDispatch();

  // Volatile list of the enabled fields
  const [checked, setChecked] = useState([]);
  // Permanent List of the enabled fields
  const [isNoItems, setIsNoItems] = useState(false);
  // To search
  const [searchText, setSearchText] = useState("");
  // To handle show all columns state
  // const [isShowAllColumns, setIsShowAllColumns] = useState(false);

  const MiColumnsFilterer = (list) => {
    // MI columns filtered based on the list given

    // const assignmentView = totalColumns.find((el) => el.field === "id");
    const filteredColumns = totalColumns
      .filter((el) => el.field !== "id")
      .map((column) => {
        const mappedField = list.find((field) => field.name === column.field);
        if (mappedField) {
          column.hidden = !mappedField.checked;
          return column;
        } else {
          return undefined;
        }
      })
      .filter((el) => el !== undefined);
    // setColumns([...filteredColumns, assignmentView]);
    setColumns(filteredColumns);
  };
  // const handleShowAllColumns = () => {
  //   setChecked((prevChecked) => {
  //     const newArr = prevChecked.map((prevCheckedEl) => {
  //       return {
  //         ...prevCheckedEl,
  //         checked: !isShowAllColumns ? true : prevCheckedEl.default === "true",
  //       };
  //     });
  //     MiColumnsFilterer(newArr);
  //     return newArr;
  //   });
  //   setIsShowAllColumns((prev) => !prev);
  // };

  const handleHideAllColumns = () => {
    setChecked((prevChecked) => {
      const newArr = prevChecked.map((prevCheckedEl) => {
        const isUncheckable = unCheckable.includes(prevCheckedEl.name);
        return {
          ...prevCheckedEl,
          checked: isUncheckable ? true : false,
        };
      });
      MiColumnsFilterer(newArr);
      return newArr;
    });
  };
  const handleText = (e) => {
    const text = e.target.value.toLowerCase();
    setSearchText(text);

    setChecked((prevChecked) => {
      const filteredList = prevChecked.map((prevCheckedElem) => {
        const prevCheckedEl = { ...prevCheckedElem };
        const label = prevCheckedEl?.label?.toLowerCase();
        if (text === "" || label.includes(text)) {
          prevCheckedEl.filter = false;
        } else {
          prevCheckedEl.filter = true;
        }
        return prevCheckedEl;
      });
      const isAnyFilter = filteredList.some((el) => el.filter === false);

      setIsNoItems(!isAnyFilter);

      return filteredList;
    });
  };

  const responseHandler = (res) => {
    if (res?.success) {
      let list = res?.mi_fields?.map((column) => {
        return {
          ...column,
          checked: column.default === "true",
          filter: false,
          disabled: unCheckable.includes(column.name),
        };
      });
      if (selectedColumns.length > 0) {
        list = list.map((column) => {
          return {
            ...column,
            checked: selectedColumns.includes(column.name),
          };
        });
      }
      // Arranging the fields as per the column orders
      const initialList = [];
      totalColumns
        .map((el) => el.field)
        .forEach((el) => {
          const element = list.find((e) => el === e.name);
          if (element) {
            initialList.push(element);
          }
        });

      setChecked(initialList);
      MiColumnsFilterer(initialList);
    }
  };

  useEffect(() => {
    DataService.getDirectData(
      `/management_information_fields/show_mi_selected_fields`
    )
      .then(responseHandler)
      .catch((err) => {});
  }, [columns.length]);

  const handleToggle = useCallback(
    (event) => {
      setChecked((prevChecked) => {
        let resultArr = [...prevChecked];
        const totalCheckedColumns = resultArr.filter((el) => el.checked) || [];
        const elemIndex = resultArr.findIndex((el) => el.name === event.name);
        if (elemIndex >= 0) {
          const elem = resultArr[elemIndex];
          elem.checked = !elem?.checked;
          if (elem.checked && totalCheckedColumns.length < 30) {
          } else {
            elem.checked &&
              dispatch(
                showSnackbar("error", ["Maximum 30 fields selected at a time"])
              );
            elem.checked = false;
          }
        }

        MiColumnsFilterer(resultArr);
        return resultArr;
      });
    },
    [MiColumnsFilterer, checked]
  );

  return (
    <>
      <Tooltip title={<TooltipWrapper text="Show Columns" />}>
        <IconButton
          style={{ padding: 0 }}
          onClick={(event) => {
            setColumnsSelectorOpen(true);
            setColumnsSelectorAnchor(event.currentTarget);
          }}
          disableRipple
        >
          <ViewColumnIcon color="secondary" />
        </IconButton>
      </Tooltip>
      <Popover
        style={{}}
        PaperProps={{
          style: {
            maxHeight: "39rem",
            minHeight: "25rem",
            width: "300px",
            padding: 0,
          },
        }}
        marginThreshold={32}
        anchorEl={columnsSelectorAnchor}
        id={"columns-selector-popover"}
        open={columnsSelectorOpen}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        onClose={() => {
          setColumnsSelectorOpen(false);
          setColumnsSelectorAnchor(null);
        }}
      >
        <div
          style={{
            paddingLeft: "0.75rem",
            paddingTop: "0.75rem",
            paddingBottom: "0.75rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: 55,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h6"
              style={{
                color: "#077F83",
                fontWeight: "bold",
                fontSize: "18px",
                // fontWeight: 700,
                fontFamily: "open sans",
              }}
            >
              Add or remove columns
            </Typography>

            <Button
              color="primary"
              style={{ textTransform: "none" }}
              onClick={handleHideAllColumns}
            >
              Clear
            </Button>
          </div>
          <TextField
            fullWidth
            placeholder={"Search columns..."}
            variant="outlined"
            value={searchText}
            InputProps={{
              startAdornment: <SearchIcon style={{ fill: "#666" }} />,
            }}
            style={{
              width: "90%",
              fontSize: "16px",
              fontFamily: "Open Sans",
            }}
            onChange={handleText}
          />
        </div>
        <List style={{ width: "100%" }}>
          {/* <ListItem
            key={"show all columns"}
            role={undefined}
            button
            onClick={handleShowAllColumns}
          >
            <ListItemIcon style={{ minWidth: "36px" }}>
              <Checkbox
                edge="start"
                checked={isShowAllColumns}
                tabIndex={-1}
                disableRipple
                inputProps={{ "aria-labelledby": " show - columns" }}
              />
            </ListItemIcon>
            <ListItemText id={"show-columns"} primary={"Show all columns"} />
          </ListItem> */}
          <Divider />
          {checked
            .filter((el) => el.filter === false)
            .map((field) => {
              const labelId = `checkbox-list-label-${field.name}`;

              return (
                <ListItem
                  key={field.name}
                  role={undefined}
                  button
                  onClick={(event) => {
                    if (!field.disabled) {
                      handleToggle(field);
                    }
                  }}
                >
                  <ListItemIcon style={{ minWidth: "36px" }}>
                    <Checkbox
                      edge="start"
                      checked={field.checked}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ "aria-labelledby": labelId }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    style={{ color: field.disabled ? "#555" : "" }}
                    id={labelId}
                    primary={field.label}
                  />
                </ListItem>
              );
            })}
          {isNoItems && (
            <ListItem key={"no_items_found"} role={undefined} disabled={true}>
              <ListItemText
                id={"show-columns"}
                primary={"No items found"}
                style={{ textAlign: "center" }}
              />
            </ListItem>
          )}
        </List>
      </Popover>
    </>
  );
};
export default React.memo(ColumnsSelector, (prev, next) => {
  console.log(prev, next, "props");
  return next.isRefetchingMiTable === false;
});
